import {forBrands, styled} from '@core-ui/react-stitch';
import {transitions} from '@core-ui/motion';

export const getIconBgColor = ({theme}) => forBrands(theme, {
  at: t => t.color.b1,
  default: t => t.color.bk,
  gap: t => t.color.b1,
  gapfs: t => t.color.b1,
  on: t => t.color.b1,
});

const sanitizeHexValue = hex => hex.replace('#', '%23');

const getTransion = expanded => {
  return `transform ${expanded
    ? transitions.expressive.in.transitionDuration
    : transitions.performance.out.transitionDuration} ${expanded
    ? transitions.expressive.in.transitionTimingFunction
    : transitions.performance.out.transitionTimingFunction} ${transitions.userTriggeredDelay}`;
};

const Chevron = styled.span(({theme, expanded}) => ({
  marginLeft: '.5rem',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: '100% 100%',
  height: '0.7rem',
  width: '0.7rem',
  transition: getTransion(expanded),
  display: 'inline-block',
  transformOrigin: 'center',
  transform: `${expanded ? 'rotate(180deg)' : 'rotate(0deg)'}`,
  backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='11' height='7' viewBox='0 0 11 7'%3E%3Cpath d='M1 1.5 L 5.5 5.5 L 10 1.5' fill='none' stroke='${sanitizeHexValue(
    getIconBgColor({theme}),
  )}' stroke-width='1.5'%3E%3C/path%3E%3C/svg%3E")`,
}));

export default Chevron;
